import type { Container, Spritesheet, Texture } from "pixi.js";
import { SymbolRemovalBurst, SymbolRemovalBurstSpawner } from "@slot/presentation";
import type { PresentationTicker } from "@slot/presentation";

/**
 * `SymbolRemovalBurst.prefab`: the `Explosion_Sheet_Yellow_20-N` frames (0..35) at 60 fps
 * on a 500×500 sprite. Frames are 338px in the sheet → scaled to 500.
 */
export function createRemovalEffectSpawner(input: {
  sheet: Spritesheet;
  parent: Container;
  ticker: PresentationTicker;
}): SymbolRemovalBurstSpawner | null {
  const frames: Texture[] = [];
  for (let i = 0; ; i++) {
    const texture = input.sheet.textures[`Explosion_Sheet_Yellow_20-${i}`];
    if (!texture) break;
    frames.push(texture);
  }
  if (frames.length === 0) return null;
  const native = Math.max(1, frames[0].orig.width);
  const scale = 500 / native;
  return new SymbolRemovalBurstSpawner(
    () => new SymbolRemovalBurst({ frames, fps: 60, ticker: input.ticker, scale }),
    input.parent,
  );
}
